<template>
  <v-container>
    <div v-if="cxData.name" class="text-h5 font-weight-bold mb-3">
      {{ cxData.name }}
    </div>
    <div class="header-buttons">
      <div>
        <v-btn color="primary" dark block @click="$router.push('/consumers')">
          Back
        </v-btn>
      </div>
      <div v-if="authPermissions.has('consumer_loans:create')">
        <export-consumer-loan
          :loading="cxLoading"
          :consumer-id="consumerId"
          :consumer-name="cxData.name || null"
        />
      </div>
      <div v-if="authPermissions.has('consumer_loans:view')">
        <v-btn color="primary" dark block @click="printSummaryOfLoans">
          Summary of Loans
        </v-btn>
      </div>
    </div>
    <v-row>
      <v-col
        v-if="authPermissions.has('consumer_loans:create')"
        cols="12"
        lg="3"
      >
        <v-toolbar color="primary" dark>
          Add Loan Batch
        </v-toolbar>
        <create-consumer-loan :prop-consumer-id="consumerId" />
      </v-col>
      <v-col
        v-if="authPermissions.has('consumer_loans:view')"
        cols="12"
        md="9"
        lg="9"
      >
        <v-toolbar color="primary" dark>
          List of Loans
        </v-toolbar>
        <index-consumer-loan
          :prop-consumer-id="consumerId"
          @edit="initEditConsumerLoan"
        />
      </v-col>
    </v-row>
    <v-dialog
      v-model="editConsumerLoan"
      dismissable
      max-width="600px"
      eager
      class="pa-0"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title>Edit</v-card-title>
        </v-toolbar>
        <edit-consumer-loan
          :prop-consumer-id="consumerId"
          :prop-consumer-loan="consumerLoan"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style lang="scss" scoped>
.header-buttons {
  display: flex;
  margin: 0px;
  margin-bottom: 10px;

  & > * {
    margin-right: 10px;
  }

  & > *:last-child {
    margin-right: 0;
  }
}
</style>
<script>
import consumerRepository from '@/repositories/consumer.repository'
import { apiVars, errorHandler } from '@/extra-functions/api-helper.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
import LoanSummary from '@/pdf/loan-summary.pdf'
import { formatAccounting } from '@/lib/utils'
import { mapState } from 'vuex'

const cxGetDelay = searchDelay(100)

export default {
  name: 'ConsumerLoan',
  components: {
    indexConsumerLoan: () =>
      import('@/views/dashboard/components/consumer-loans/Index'),
    createConsumerLoan: () =>
      import('@/views/dashboard/components/consumer-loans/Create'),
    editConsumerLoan: () =>
      import('@/views/dashboard/components/consumer-loans/Edit'),
    exportConsumerLoan: () => import('./Export'),
  },
  data() {
    return {
      consumerId: this.$route.params.consumer,
      consumerLoan: {},
      editConsumerLoan: false,
      gettingSummaryOfLoans: false,
      ...apiVars('cx', { data: {} }),
    }
  },
  created() {
    this.getConsumers()
  },
  mounted() {
    console.log({ ...this.$route.query })
  },
  computed: {
    ...mapState({
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  methods: {
    getConsumers() {
      if (this.cxLoading) return
      cxGetDelay(() => {
        consumerRepository
          .show(this.consumerId)
          .then(({ data }) => {
            this.cxData = data
          })
          .catch((e) => {
            this.cxErrors = errorHandler(e)
          })
          .then(() => {
            this.cxLoading = false
          })
      })
    },
    initEditConsumerLoan(consumerLoan) {
      this.consumerLoan = consumerLoan
      this.editConsumerLoan = true
    },
    async printSummaryOfLoans() {
      try {
        if (this.gettingSummaryOfLoans) return
        this.gettingSummaryOfLoans = true
        const { data } = await consumerRepository.summaryOfLoans(
          this.consumerId,
        )
        const loanSummary = new LoanSummary()
        const summaryData = {
          name: data?.name,
          paidAmount: formatAccounting(data?.total_paid_amount),
          totalAmount: formatAccounting(data?.total_amount),
          balance: formatAccounting(data?.balance),
          address: data?.address,
        }
        const summaryItems = data.items.map((item) => {
          return {
            receiptNo: item?.receipt_no?.trim(),
            noOfItems: item.no_of_items,
            amount: formatAccounting(item.amount),
            paidAmount: formatAccounting(item.paid_amount),
            unpaidAmount: formatAccounting(item.unpaid_amount),
          }
        })

        loanSummary.generate(summaryData, summaryItems)
      } catch (e) {
        alert('oops something went wrong')
      } finally {
        this.gettingSummaryOfLoans = false
      }
    },
  },
}
</script>
